import Configuration from '@/agilis/util/Configuration'
import FormDataTable from '@/agilis/components/Form/FormDataTable/FormDataTable.vue'
import L from 'lodash'

const d = require('deepdash').default
d(L)

const defaultValue = {
  columns: {
    value: {
      id: 'value',
      type: 'text',
      label: '',
      required: true
    }
  },
  formRows: [
    {
      cols: ['value']
    }
  ]
}

export default {
  name: 'formList',
  firstLoad: false,

  components: {
    FormDataTable
  },

  props: {
    fieldConfig: Object,
    value: Array,
    disabled: Boolean
  },

  data: () => ({
    items: [],
    innerValue: [],
    innerFieldConfig: null,
    columnId: null
  }),

  watch: {
    innerValue: {
      handler (newValue) {
        if (this.$options.firstLoad) {
          this.$options.firstLoad = !this.$options.firstLoad
          return
        }
        const newItems = newValue.map(item => {
          return item[this.columnId]
        })
        L.remove(this.items)
        this.items.push(...newItems)
        this.$emit('change', { [this.innerFieldConfig.id]: this.items })
      }
    }
  },

  created () {
    this.innerFieldConfig = L.cloneDeep(this.fieldConfig)
    if (!this.innerFieldConfig.columns) {
      this.innerFieldConfig.columns = defaultValue.columns
      this.innerFieldConfig.formRows = defaultValue.formRows
    }
    this.columnId = Object.keys(this.innerFieldConfig.columns)[0]
    this.items = this.value
    if (this.fieldConfig.query) {
      this.innerFieldConfig.query = null
      const url = this.$axios.agilisUrlQuery(this.applicationId, this.fieldConfig.query)
      const filter = { field: this.fieldConfig.propsWhen.filter.field, operator: 'EQUALS', value: this.fieldConfig.filter }
      const body = Configuration.datatable.paginatedRequestBody(this.fieldConfig, {}, '', [filter], [])
      const config = this.$axios.agilisRequestConfig(url)

      this.$axios.post(url, body, config).then((response) => {
        this.items = response.data.items
      }).catch((error) => {
        this.notifyError(error)
      })
    }
    this.$options.firstLoad = true
    this.formatInnerValue(this.items)
  },

  methods: {
    formatInnerValue (items) {
      if (items) {
        this.innerValue = items.map(item => {
          return {
            [this.columnId]: item
          }
        })
      }
    }
  }

}
